import { c as _c } from "react/compiler-runtime";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { useMembersMenuOptions } from "@pages/members/use-members-menu-options";
/**
 * Renders a 3-dot menu with actions for a single member row in the table.
 */
export function MemberOptionsMenu(t0) {
  const $ = _c(8);
  const {
    member,
    subjectType,
    selectedProject,
    group,
    team
  } = t0;
  let t1;
  if ($[0] !== group || $[1] !== selectedProject || $[2] !== subjectType || $[3] !== team) {
    t1 = {
      subjectType,
      selectedProject,
      group,
      team
    };
    $[0] = group;
    $[1] = selectedProject;
    $[2] = subjectType;
    $[3] = team;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const menuItems = useMembersMenuOptions(t1);
  let t2;
  if ($[5] !== member || $[6] !== menuItems) {
    t2 = <ListItemMenu item={member} menuItems={menuItems} />;
    $[5] = member;
    $[6] = menuItems;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}